import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import grading from './modules/grading'
import organization from './modules/organization'
import keys from './modules/keys'
import account from './modules/account'
import api from '@/store/plugins/api'
const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)
Vue.use(api(Vuex))
const filter = (mutation, prevState, nextState) => {
  const fitlerList = ['SET_TIMES']
  return !(fitlerList.indexOf(mutation.type) > -1)
}
export default new Vuex.Store({
  state: {
  },

  mutations: {
    USER_RESTORE (state, user) {
      console.log(user)
      state.user = user
    },
    SIGNOUT (state) {
      state.user = {}
      state.account = {
        token: '',
        tokenExpiredAt: new Date()
      }
    }
  },
  getters: {
  },
  modules: {
    keys,
    grading,
    organization,
    account
  },
  plugins: debug ? [createLogger({ filter })] : []
})
